import AppProviders from '@/providers/AppProviders';

const App = () => <AppProviders />;

export default App;
